import { combineReducers } from "redux";
import persistReducer from "redux-persist/es/persistReducer";
import storage from "redux-persist/lib/storage";
import userSlice from "../reducers/User/userSlice"

const persistConfig = {
    key: "root",
    storage,
    whitelist: [],
};

const rootReducer = combineReducers({
    userDetails: userSlice
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default persistedReducer;
